import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "../App.css";
import { apiUrl } from "../config/apiBase";
import logoLight
  from "../obr/FCA_App_black2.png";
import logoDark
  from "../obr/FCA_App_gold2.png";

export default function ResetHesla() {
    const nav = useNavigate();
  const [
    searchParams
  ] =
    useSearchParams();

  const token =
    String(
      searchParams.get(
        "token"
      ) || ""
    ).trim();

  const [
    password,
    setPassword
  ] =
    useState("");

  const [
    password2,
    setPassword2
  ] =
    useState("");

  const [
    err,
    setErr
  ] =
    useState("");

  const [
    ok,
    setOk
  ] =
    useState("");

  const [
    odosielam,
    setOdosielam
  ] =
    useState(false);

  const nacitajTemu = () => {
    const ulozena =
      localStorage.getItem(
        "tema"
      );

    return ulozena ===
      "dark"
      ? "dark"
      : "light";
  };

  const [tema] =
    useState(
      nacitajTemu
    );

  const aktualneLogo =
    tema === "light"
      ? logoLight
      : logoDark;

  useEffect(() => {
    document.documentElement
      .setAttribute(
        "data-theme",
        tema
      );
  }, [tema]);

  const onSubmit =
    async (e) => {
      e.preventDefault();

      if (
        odosielam ||
        ok
      ) {
        return;
      }

      setErr("");
      setOk("");

      if (
        password !==
        password2
      ) {
        setErr(
          "Heslá sa nezhodujú."
        );
        return;
      }

      if (
        password.length < 8
      ) {
        setErr(
          "Heslo musí mať aspoň 8 znakov."
        );
        return;
      }

      setOdosielam(
        true
      );

      try {
        const r =
          await fetch(
            apiUrl(
              "/api/auth/reset-hesla"
            ),
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body:
                JSON.stringify({
                  token,
                  password,
                  password2
                })
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Heslo sa nepodarilo zmeniť."
          );
        }

        setPassword("");
        setPassword2("");

        setOk(
          data?.message ||
            "Heslo bolo úspešne zmenené."
        );

        setTimeout(() => {
            nav(
                "/login",
                {
                replace: true
                }
            );
            }, 1200);

      } catch (e2) {
        setErr(
          e2.message ||
            "Heslo sa nepodarilo zmeniť."
        );
      } finally {
        setOdosielam(
          false
        );
      }
    };

  return (
    <div className="login-page">
      <div className="login-shell">

        <div className="login-logo-wrap">
          <img
            src={aktualneLogo}
            alt="FinCloud"
            className="login-logo"
          />
        </div>

        <div className="App login-app">
          <div className="card-section login-card">

            <h2>
              Nové heslo
            </h2>

            {!token ? (
              <>
                <div className="form_hint error">
                  Odkaz na obnovenie hesla nie je platný.
                </div>

                <div className="form-actions form-actions--full">
                  <Link
                    to="/zabudnute-heslo"
                    className="login-forgot-link"
                  >
                    Požiadať o nový odkaz
                  </Link>
                </div>
              </>
            ) : (
              <form
                onSubmit={onSubmit}
                className="form-group"
              >

                <div className="form form--full">

                  <label className="form_label">
                    Nové heslo
                  </label>

                  <input
                    className="form_input"
                    type="password"
                    value={password}
                    onChange={
                      (e) =>
                        setPassword(
                          e.target.value
                        )
                    }
                    autoComplete="new-password"
                    required
                  />

                </div>

                <div className="form form--full">

                  <label className="form_label">
                    Potvrdenie nového hesla
                  </label>

                  <input
                    className="form_input"
                    type="password"
                    value={password2}
                    onChange={
                      (e) =>
                        setPassword2(
                          e.target.value
                        )
                    }
                    autoComplete="new-password"
                    required
                  />

                  {err && (
                    <div className="form_hint error">
                      {err}
                    </div>
                  )}

                  {ok && (
                    <div className="form_hint">
                      {ok}
                    </div>
                  )}

                </div>

                <div className="form-actions form-actions--full">

                  {!ok && (
                    <button
                      type="submit"
                      className="form_input action-btn"
                      disabled={
                        odosielam
                      }
                    >
                      {odosielam
                        ? "Ukladám..."
                        : "Uložiť nové heslo"}
                    </button>
                  )}

                  <Link
                    to="/login"
                    className="login-forgot-link"
                  >
                    Späť na prihlásenie
                  </Link>

                </div>

              </form>
            )}

          </div>
        </div>

      </div>
    </div>
  );
}